import ActionsMetricsForm from "../../view/workflows/actionForms/ActionsMetrics/Form.vue";

export default {
  workflows: ActionsMetricsForm,
};
